module.exports = __webpack_public_path__ + "img/新乡市-c.6b6db7a4.png";